// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PbsMY","title":"styles_title__2DdNN"};